//own imports
import './InsertExpense.css'
import LoadingGif from '../../../images/LoadingGif.gif';

//import react
import React, {
    useState,
    useEffect,
    useRef
} from 'react';
import DatePicker from "react-datepicker";
import Dropdown from 'react-dropdown';
import 'react-tiny-fab/dist/styles.css';
import 'react-dropdown/style.css';
import "react-datepicker/dist/react-datepicker.css";
import {
    useParams, 
    useLocation,
    Link
} from "react-router-dom";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

//firebase
import { getAuth, onAuthStateChanged } from "firebase/auth";

import { addDoc, collection } from "firebase/firestore";
import { getFirestore, Timestamp, query, getDoc, doc, where, getDocs, updateDoc, arrayUnion } from "firebase/firestore";

import { getDownloadURL, getStorage, ref, uploadBytes}   from "firebase/storage";


const storage = getStorage();
const db = getFirestore();
const auth = getAuth();

let currenUserLoaded = false;

const InsertExpense = () => {

    const[startDate, setStartDate] = useState(new Date());
    const[canCreateExpense, setCanCreateExpense] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [currentUserPermissions, setCurrentUserPermissions] = useState("");

    //expense
    const [expense, setExpense] = useState(null);

    //groups and categories
    const [groups, setGroups] = useState([]);
    const [categories, setCategories] = useState([]);
    const [groupIdSet, setGroupIdSet] = useState(true);
    const [expenseIdSet, setExpenseIdSet] = useState(true);
    const [groupIdFound, setGroupIdFound] = useState(null);

    //retrieving params from url als deze '0' terug geeft -> dan moet er een group gekozen worden aan de hand van een dropdown. als deze niet '0' geeft maar een id van een group dan moet de gebruiker geen groep aanduiden.
    const { groupId } = useParams();
    const { expenseId } = useParams();
    const {photo} = useLocation();


    const photoRef = useRef(null);




    useEffect(() => {
        setUp();

        if (photo !== undefined && photo !== null) {
            getPhotoData();
        }

        onAuthStateChanged(auth, (user) => {
            if (user !== null && currentUser === null && currenUserLoaded === false) {
                getCurrentUser();
            }
        });

        getCurrentUser();
        getCategoriesAndGroups();

        if (groupId !== "null") {
            setGroupIdSet(true);
        } else {
            setGroupIdSet(false);
        }
        
        if (expenseId !== "null") {
            setExpenseIdSet(true);
            loadCurrentExpense();
        }
        else { 
            setExpenseIdSet(false); 
        }
        if (expenseId !== "null") {
            getCurrentPicture();
        }



    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (groupIdSet === false) {
        return (<div style={{minHeight:'100vh'}}>
            <h1 className="header">Insert Expense</h1>
            <div className="btnScanExpenseGroup">

                <button style={{ marginBottom: '1.7rem' }} className="btn-primary btnScanExpense" onClick={goToScanPage}>Take Picture for Expense</button>
                <canvas ref={photoRef} className='photoExpense' style={{ maxWidth: '80%' }}></canvas>

            </div>
            <div className="fromContainer">
                <form className="insertExpenseForm">
                    <label className="label" htmlFor="desc">Name</label>
                    <input onInput={formvalidation} className="inputField" type="text" name="desc" id="desc" /><br />
                    <label className="label" htmlFor="price">Price</label>
                    <input onInput={formvalidation} className="inputField" type="number" name="price" id="price" /> <br />
                    <label className="label" htmlFor="date">Date</label>
                    <DatePicker selected={startDate} onChange={(date) => { setStartDate(date); formvalidation(); }} className="inputField" id="date"></DatePicker>
                    <label className="label" htmlFor="cate">Category</label> <br /> <br /> <br />
                    <Dropdown options={categories} onChange={formvalidation} style={{ border: '2px solid' }} className="inputField ddInsertExpense" id="category">
                    </Dropdown>
                    <label className="label" htmlFor="group">Group</label><br /> <br />
                    <Dropdown onChange={formvalidation} options={groups} className="inputField ddInsertExpense" id="group"></Dropdown>
                    <span className="errorMessage"></span>
                </form>
            </div>
            <div className="uploadingPhotoBox">
                <p>Uploading expense ...</p>
                <img src={LoadingGif} alt="Loading" />
            </div>
            <div className="btnInserExpenseGroup">
                <button disabled={!canCreateExpense} style={{ filter: "grayscale(1)" }} className="btn-primary btnInsertExpense" onClick={saveExpense}>Save Expense</button>
                <button className="btn-secondary" onClick={cancel}>Cancel</button>
            </div>
            </div>);
    }
    else if (groupIdSet === true && expenseIdSet === true) {
        return (<div style={{ minHeight: '100vh' }}>
            <h1 className="header">Edit Expense</h1>
            <div className="btnScanExpenseGroup">

                <button style={{ marginBottom: '1.7rem' }} className="btn-primary btnScanExpense" onClick={goToScanPage}>Scan Expense</button>
                <canvas ref={photoRef} className='photoExpense' style={{ maxWidth: '80%' }}></canvas>

            </div>
            <div className="fromContainer">
                <form className="insertExpenseForm">
                    <label className="label" htmlFor="desc">Name</label>
                    <input  className="inputField" type="text" name="desc" id="desc" /><br />
                    <label className="label" htmlFor="price">Price</label>
                    <input  className="inputField" type="number" name="price" id="price" /> <br />
                    <label className="label" htmlFor="date">Date</label>
                    <DatePicker selected={startDate} showTimeSelect onChange={(date) => { setStartDate(date); formvalidation(); }} className="inputField" id="date"></DatePicker>
                    <label className="label" htmlFor="cate">Category</label> <br /> <br /> <br />
                    <Dropdown options={categories}  style={{ border: '2px solid' }} className="inputField ddInsertExpense" id="category"></Dropdown>
                    <label className="label" htmlFor="group">Group</label><br /> <br />
                    <Dropdown  options={groups} className="inputField ddInsertExpense" id="group"></Dropdown>
                    <span className="errorMessage"></span>
                </form>
            </div>
            <div className="currentPhoto">
                <h2>Current Photo</h2>
                <p style={{ margin: '0.3rem', fontSize: '20px', color: 'lightslategray' }} className='photoInfo'></p>
                <img src={LoadingGif} className='loadingGif' alt="Loading" />
                <img style={{ maxWidth: '70%' }} className='detailPhotoValue expenseImg' id='expenseImg' alt=''></img>
            </div>
            <div className="uploadingPhotoBox">
                <p>Uploading expense ...</p>
                <img src={LoadingGif} alt="Loading" />
            </div>
            <div className="btnInserExpenseGroup">
                <button className="btn-primary btnUpdateExpense" onClick={updateExpense}>Update Expense</button>
                <Popup trigger={<button className="btn-danger" >Delete Expense</button>} position="center" modal>
                    {close => (
                        <div className="popUpDeleteGroup">
                            <div className="popUpDeleteGroup_header"> Delete Expense </div>
                            <div className="popUpDeleteGroup_content">Are you sure to delete this expense?</div>
                            <div className="popUpDeleteGroup_actions">
                                <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Cancel</button>
                                <button className="btn-danger" onClick={deleteExpense}>Delete Expense</button>
                            </div>
                        </div>
                    )}
                </Popup>
                {
                    currentUserPermissions.includes("CreateRemoveGroupCategories") === true ? <Popup trigger={<button className="btn-secondary" >Add Category</button>} position="center" modal>
                        {close => (
                            <div className="popUpDeleteGroup">
                                <div className="popUpDeleteGroup_header"> Add Category </div>
                                <div className="popUpDeleteGroup_content">
                                    <p>Please fill in the name of the new Category</p>
                                    <input type="text" className="inputField" name="category" id="categoryAddInput" />
                                </div>
                                <div className="popUpDeleteGroup_actions">
                                    <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Cancel</button>
                                    <button className="btn-primary" onClick={() => { addCategoryToGroup(); }}>Add Category</button>
                                </div>
                            </div>
                        )}
                    </Popup> : 
                    <div></div>
                }
                <button className="btn-secondary" onClick={cancel}>Cancel</button>
            </div>
            </div>);
    }
    else
        {
        return (<div style={{ minHeight: '100vh' }}>
            <h1 className="header">Insert Expense</h1>
            <div className="btnScanExpenseGroup">

                <Link to={`/scan/${groupId}/${expenseId}`}><button style={{ marginBottom: '1.7rem' }} className="btn-primary btnScanExpense" >Scan Expense</button></Link>


                <canvas ref={photoRef} className='photoExpense' style={{maxWidth:'80%'}}></canvas>


            </div>
            <div className="fromContainer">
            <form className="insertExpenseForm">
                <label className="label" htmlFor="desc">Name</label>
                <input onInput={formvalidation} className="inputField" type="text" name="desc" id="desc" /><br />
                <label className="label" htmlFor="price">Price</label>
                <input onInput={formvalidation} className="inputField" type="number" name="price" id="price" /> <br />
                <label className="label" htmlFor="date">Date</label>
                <DatePicker selected={startDate} showTimeSelect onChange={(date) => { setStartDate(date); formvalidation(); }} className="inputField" id="date"></DatePicker>
                <label className="label" htmlFor="cate">Category</label> <br /> <br /> <br />
                <Dropdown options={categories} onChange={formvalidation} style={{ border: '2px solid' }} className="inputField ddInsertExpense" id="category"></Dropdown>
                <p>Group Ok</p>
                <span className="errorMessage"></span>
            </form>
        </div>
            <div className="uploadingPhotoBox">
                <p>Uploading expense ...</p>
                <img src={LoadingGif} alt="Loading" />
            </div>
            <div className="btnInserExpenseGroup">
                <button disabled={!canCreateExpense} style={{ filter: "grayscale(1)" }} className="btn-primary btnInsertExpense" onClick={saveExpense}>Save Expense</button>
                {
                    currentUserPermissions.includes("CreateRemoveGroupCategories") === true ? <Popup trigger={<button className="btn-secondary" >Add Category</button>} position="center" modal>
                        {close => (
                            <div className="popUpDeleteGroup">
                                <div className="popUpDeleteGroup_header"> Add Category </div>
                                <div className="popUpDeleteGroup_content">
                                    <p>Please fill in the name of the new Category</p>
                                    <input type="text" className="inputField" name="category" id="categoryAddInput" />
                                </div>
                                <div className="popUpDeleteGroup_actions">
                                    <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Cancel</button>
                                    <button className="btn-primary" onClick={() => { addCategoryToGroup(); }}>Add Category</button>
                                </div>
                            </div>
                        )}
                    </Popup> :
                        <div></div>
                }
                <button className="btn-secondary" onClick={cancel}>Cancel</button>
            </div>
           </div>);
        }

    //methods

    function getPhotoData(){
        
        var destinationCtx = document.getElementsByClassName('photoExpense')[0].getContext('2d');

        document.getElementsByClassName('photoExpense')[0].width = photo.width;
        document.getElementsByClassName('photoExpense')[0].height = photo.height;

        destinationCtx.drawImage(photo, 0, 0);
    }

    async function addCategoryToGroup(close){
        const categoryName = document.getElementById("categoryAddInput").value;
        const errorMessage = document.getElementsByClassName('errorMessage')[0];

        if(categoryName === ""){
            document.getElementById("categoryAddInput").style.border = "2px solid red";
            return;
        }
        else{
            document.getElementById("categoryAddInput").style.border = "none";

            try {
                await updateDoc(doc(db, "Groups", groupId), {
                    categories : arrayUnion(categoryName),
                });
                window.location.reload();
            } catch (e) {
                errorMessage.innerHTML = "Error adding category to group: "+ e;
            }
        }
    }

    async function getCategoriesAndGroups(){
        const errorMessage = document.getElementsByClassName('errorMessage')[0];

        try {
            const getCateFromFirebase = [];
            const q = doc(db, "/DefaultCategories", "defaultCategories");

            const docSnap = await getDoc(q);
            if (docSnap.exists()) {
                getCateFromFirebase.push({ key: docSnap.data().housing, label: docSnap.data().housing }, { key: docSnap.data().food, label: docSnap.data().food, }, { key: docSnap.data().transport, label: docSnap.data().transport, }, { key: docSnap.data().ensurance, label: docSnap.data().ensurance, }, { key: docSnap.data().clothes, label: docSnap.data().clothes, }, { key: docSnap.data().housing, label: docSnap.data().recreation, });

               if (groupId !== null) {
                   const q = doc(db, "/Groups", groupId);
                     const docSnap = await getDoc(q);
                   if (docSnap.exists()) {
                       docSnap.data().categories.forEach(element => {
                           getCateFromFirebase.push({ value: element, label: element });
                       });
                   }
                   else {

                       if(groupId !== "null"){
                           errorMessage.innerHTML = "No such group!";
                       }
                   }
               }
                setCategories(getCateFromFirebase);
            } else {
                // doc.data() will be undefined in this case
               errorMessage.innerHTML = "No categeries found! Try again";
            }
        } catch (error) {
            errorMessage.innerHTML = "Error getting documents: "+ error;
        }
    }

    async function getGroups(uid) {
        const errorMessage = document.getElementsByClassName('errorMessage')[0];
        const getGroupsFromFirebase = [];

        try {


            const queryGroup = query(collection(db, "Groups"), where("members", "array-contains", uid), where("isDeleted", "==", false));
            const queryGroupSnapshot = await getDocs(queryGroup);
            queryGroupSnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                getGroupsFromFirebase.push({ value: doc.id, label: doc.data().name });
            });
        } catch (error) {
            errorMessage.innerHTML = "Problem while retrieving groups: " +error;
        }

        try {
            getGroupsFromFirebase.forEach(element => {
                if (element.value === groupId) {
                    document.getElementsByClassName('Dropdown-placeholder')[1].innerText = element.label;
                }
            });

        } catch (error) {
            //errorMessage.innerHTML = "Problem while selecting group " + error;
        }  
        setGroups(getGroupsFromFirebase);
    }

    //checking of price description are filled in
    function formvalidation() {
        var desc = document.getElementById("desc").value;
        var price = document.getElementById("price").value;
        var date = document.getElementById("date").value;
        var cate = document.getElementsByClassName("ddInsertExpense")[0].innerText;
        var errorMessage = document.getElementsByClassName("errorMessage")[0];
        try {
            var group = document.getElementsByClassName("ddInsertExpense")[1].innerText;

            if (desc === "" || price === "" || date === "" || cate === "Select..." || group === "Select..." || isNaN(price) || parseInt(price) <= 0) {
                errorMessage.innerHTML = "Please fill in all fields";
                setCanCreateExpense(false);
                document.getElementsByClassName("btnInsertExpense")[0].style.filter = "grayscale(1)";
                return;
            }
            else {
                errorMessage.innerHTML = "";
                setCanCreateExpense(true);
                document.getElementsByClassName("btnInsertExpense")[0].style.filter = "grayscale(0)";
                return;
            }
        } catch (error) {
            if (desc === "" || price === "" || date === "" || cate === "Select..." || isNaN(price) || parseInt(price) <= 0) {
                errorMessage.innerHTML = "Please fill in all fields";
                setCanCreateExpense(false);
                document.getElementsByClassName("btnInsertExpense")[0].style.filter = "grayscale(1)";
                return;
            }
            else {
                errorMessage.innerHTML = "";
                setCanCreateExpense(true);
                document.getElementsByClassName("btnInsertExpense")[0].style.filter = "grayscale(0)";
                return;
            }
        }
    }

    function setUp() {
        document.title = "Insert Expense";
    };

    function goToScanPage() {
        window.location.href = `/scan/${groupId}/${expenseId}`;
    };

    function cancel() {
        window.history.go(-1);
    };

    async function getCurrentUser() {
        const errorMessage = document.getElementsByClassName('errorMessage')[0];

        let permissions = "";
        if (auth.currentUser !== null && currentUser === null) {
            currenUserLoaded = true;
            setCurrentUser(auth.currentUser);
            getGroups(auth.currentUser.uid);
           try {
               const cMember = await getDocs(query(collection(db, "Groups", groupId, "Members"), where("uid", "==", auth.currentUser.uid)));
               cMember.forEach(element => {
                   if (element.data().permissions[0].CreateRemoveGroupCategories) {
                       permissions += "CreateRemoveGroupCategories ";
                   }
                   if (element.data().permissions[0].EditRemoveOtherTheirExpenses) {
                       permissions += "EditRemoveOtherTheirExpenses ";
                   }
                   setCurrentUserPermissions(permissions);
               });
           } catch (error) {
               errorMessage.innerHTML = "Problem getting member: " + error;
           }
        }
    }

    function getCurrentPicture(){


       if (expenseId !== null) {
           try {
               const storageRef = ref(storage, `/expensesPhoto/${expenseId}`);
               getDownloadURL(storageRef)
                   .then(function (url) {
                       const img = document.getElementById('expenseImg');
                       img.setAttribute('src', url);
                       document.getElementsByClassName('loadingGif')[0].style.display = 'none';
                   })
                   .catch(function (error) {
                       if (error.code === "storage/object-not-found") {
                           try {
                               document.querySelector('.photoInfo').innerHTML = "No photo";
                           } catch (error) {
                               document.getElementsByClassName('errorMessage')[0].innerHTML = "No photo";
                           }
                       }
                       else {
                           document.getElementsByClassName('errorMessage')[0].innerHTML = error.message;
                       }
                   });
           } catch (error) {
               document.getElementsByClassName('errorMessage')[0].innerHTML = "No photo";
           }
       }
       else document.querySelector('.photoInfo').innerHTML = "No photo";
    }

    async function loadCurrentExpense(){
        const errorMessage = document.getElementsByClassName('errorMessage')[0];

       try {
           const q = doc(db, "/Groups", groupId, "/Expenses", expenseId);
           const docSnap = await getDoc(q);
           if (docSnap.exists()) {
               document.getElementById('desc').value = docSnap.data().name;
               setStartDate(new Date(docSnap.data().date.seconds * 1000));
               document.getElementById('price').value = docSnap.data().price;
               document.getElementsByClassName('Dropdown-placeholder')[0].innerText = docSnap.data().category;
               setExpense(docSnap.data());
           }
           else {
               errorMessage.innerHTML = "No such expense!";
           }
       } catch (error) {
           errorMessage.innerHTML = "Problem loading expenses: " + error;
       }
    }

    function updateExpense(){
        goBack();

        async function writingToDB(_callback) {
            const errorMessage = document.getElementsByClassName('errorMessage')[0];

            try {
                document.getElementsByClassName('uploadingPhotoBox')[0].style.display = "inline-block";

                let usedGroupId = groupId;

                    groups.forEach(element => {
                        if (element.label === document.getElementsByClassName("ddInsertExpense")[1].innerText) {
                            usedGroupId = element.value;
                        }
                    });

                if (groupId !== usedGroupId) { //veranderen van group -> geen historiek
                    await deleteExpense();
                    await saveExpense();
                    return;
                }

                //current expense values to the history collection
                if (usedGroupId !== "null") {

                   addDoc(collection(db, "Groups", usedGroupId, "Expenses", expenseId, "History"), {
                        category: expense.category,
                        date: Timestamp.fromDate(new Date(expense.date.seconds * 1000)),
                        isDeleted: true,
                        name: expense.name,
                        price: expense.price,
                    });

                    await updateDoc(doc(db, "/Groups", usedGroupId, "/Expenses", expenseId), {
                        name: document.getElementById('desc').value,
                        date: Timestamp.fromDate(new Date(document.getElementById('date').value)),
                        price: document.getElementById('price').value,
                        category: document.getElementsByClassName('ddInsertExpense')[0].innerText,
                    });
                
                if (photo !== null && photo !== undefined) {
                    //photo updaten naar een nieuwere versie van het ticket 
                    // rekening houdend met dat er bij de initiele insert geen photo was bij geleverd 
                    //-> zoeken naar id van de expense is deze er niet nieuw opslaan is deze erwel data update naar nieuwe foto.
                    //storage /[storage]/expensesPhoto/[id from expense]
                    photoRef.current.toBlob(function (blob) {
                        var image = new Image();
                        image.src = blob;
                        const storageRef = ref(storage, `/expensesPhoto/${expenseId}`);
                        uploadBytes(storageRef, blob)
                            .then(function (snapshot) {
                                if (groupId == null || groupId === undefined || groupId === "null") {
                                    if (groupIdFound == null || groupIdFound === undefined || groupIdFound === "") {
                                        window.location.href = "/";
                                    }
                                    else {
                                        window.location.href = "/expenses/" + groupIdFound;
                                    }
                                }
                                else {
                                    window.location.href = "/expenses/" + groupId;

                                }
                            })
                            .catch(function (error) {
                                document.getElementsByClassName('errorMessage')[0].innerText = error;
                                document.getElementsByClassName('uploadingPhotoBox')[0].style.display = "none";

                            });
                    }); 
                    }
                else {
                    if (groupId == null || groupId === undefined || groupId === "null") {
                        if (groupIdFound == null || groupIdFound === undefined || groupIdFound === "") {
                            window.location.href = "/";
                        }
                        else {
                            window.location.href = "/expenses/" + groupIdFound;
                        }
                    }
                    else {
                        window.location.href = "/expenses/" + groupId;
                    }
                }
                }
                else {

                    document.getElementsByClassName('uploadingPhotoBox')[0].style.display = "none";
                    document.getElementsByClassName('errorMessage')[0].innerText = "No groupId";
                };
            }catch (e) {
               document.getElementsByClassName('errorMessage')[0].innerText = "Error adding document: " + e;
                document.getElementsByClassName('uploadingPhotoBox')[0].style.display = "none";
                errorMessage.innerHTML = "Error adding document: ";
            }
            _callback();
        }

        function goBack() {
            writingToDB(function () {
              
            })
        }
    }

    async function deleteExpense(){
        goToExpenses();
        const errorMessage = document.getElementsByClassName('errorMessage')[0];

        async function writingToDB(_callback) {
            try {
                await updateDoc(doc(db, "/Groups", groupId, "/Expenses", expenseId), {
                    isDeleted: true,
                });
            } catch (e) {
                errorMessage.innerHTML = "Error deleting document: ";
            }
            _callback();
        }

        function goToExpenses() {
            writingToDB(function () {
                window.location.href = "/expenses/" + groupId;
            })
        }
    }

    async function saveExpense() {

        goBack();

        async function writingToDB(_callback) {
            const errorMessage = document.getElementsByClassName('errorMessage')[0];

            try {

                document.getElementsByClassName('uploadingPhotoBox')[0].style.display = "inline-block";

                let usedGroupId = groupId;
                   try {
                       groups.forEach(element => {
                           if (element.label === document.getElementsByClassName("ddInsertExpense")[1].innerText) {
                               usedGroupId = element.value;
                           }
                       });
                   } catch (error) {
                       errorMessage.innerHTML = 'Not changed from group';
                   }

                   setGroupIdFound(usedGroupId);
                   
                if (usedGroupId !== "null") {
                    const addExpense = await addDoc(collection(db, "Groups", usedGroupId, "Expenses"), {
                        name: document.getElementById('desc').value,
                        date: Timestamp.fromDate(new Date(document.getElementById('date').value)),
                        price: document.getElementById('price').value,
                        category: document.getElementsByClassName('ddInsertExpense')[0].innerText,
                        owner: currentUser.uid,
                        isDeleted: false,
                    });
               
                    if (photo !== null && photo !== undefined) {
                    //photo uploaden naar storage 
                    //storage /[storage]/expensesPhoto/[id from expense]

                    photoRef.current.toBlob(function (blob) {
                        var image = new Image();
                        image.src = blob;
                        const storageRef = ref(storage, `/expensesPhoto/${addExpense.id}`);
                        uploadBytes(storageRef, blob)
                            .then(function (snapshot) {
                                if (groupId == null || groupId === undefined || groupId === "null") {
                                    if (groupIdFound == null || groupIdFound === undefined || groupIdFound === "") {
                                        window.location.href = "/";
                                    }
                                    else {
                                        window.location.href = "/expenses/" + groupIdFound;
                                    }
                                }
                                else {
                                    window.location.href = "/expenses/" + groupId;
                                }
                            })
                            .catch(function (error) {
                                document.getElementsByClassName('errorMessage')[0].innerText = error;

                            });
                    }); 
                    }
                    else{
                        if (groupId == null || groupId === undefined || groupId === "null") {
                            if (groupIdFound == null || groupIdFound === undefined || groupIdFound === "") {
                                window.location.href = "/";
                            }
                            else {
                                window.location.href = "/expenses/" + groupIdFound;
                            }
                        }
                        else {
                            window.location.href = "/expenses/" + groupId;
                        }
                    }
                }
                else{

                    document.getElementsByClassName('errorMessage')[0].innerText = "No groupId";
                    
                    document.getElementsByClassName('uploadingPhotoBox')[0].style.display = "none";

                };
            }catch (e) {
                 document.getElementsByClassName('errorMessage')[0].innerText = "Error adding document: " + e;
                document.getElementsByClassName('uploadingPhotoBox')[0].style.display = "none";
                errorMessage.innerHTML = "Error adding document: ";

            }
            _callback();
        }

        function goBack() {
            writingToDB(function () {
            })
        }

    }
}

export default InsertExpense;